import Seo from "../components/Seo";
import PageHeader, { DetailRow } from "../components/PageHeader";
import CtaSection from "../components/CtaSection";
import { Reveal } from "../components/Reveal";

const TOPICS = [
  {
    title: "Organizing financial records",
    body: "Planning starts with records you trust. We look at how your books stand today. What’s current, what’s missing, what’s inconsistent. And get them to a state where planning is even possible.",
  },
  {
    title: "Preparation readiness",
    body: "When preparation season arrives, ready is better than frantic. We help you know what you’ll need, where it lives, and what tends to hold owners up. Before it’s urgent.",
  },
  {
    title: "Estimated-payment questions",
    body: "If your situation raises questions about estimated payments. Amounts, timing, whether they apply to you this year. We’ll help you frame those questions correctly and coordinate with your tax preparer where filing is involved.",
  },
  {
    title: "Business changes",
    body: "Hiring, letting go, changing entity type, buying equipment, moving to a new location. Changes ripple through your tax picture. Planning conversations look at what’s changing and what’s worth clarifying early.",
  },
  {
    title: "Coordinating business and owner-level questions",
    body: "The business and the owner are separate taxpayers, but the decisions aren’t separate. We help you see both sides together so a choice in one place doesn’t surprise you in the other.",
  },
];

export default function TaxBusiness() {
  return (
    <>
      <Seo
        title="Business Tax Planning | Directive Optive Solutions"
        description="Business tax planning conversations: organized records, preparation readiness, estimated-payment questions, business changes, and owner-level coordination."
        path="/tax-planning/business"
      />
      <PageHeader
        eyebrow="Business Tax Planning"
        title="For owners who’d rather see the year coming."
        lead="Tax planning for your business starts long before any deadline. It’s organized records, readiness, and early conversations about what’s changing. So decisions get made on purpose."
        image="/img/photo-summit-partner.webp"
        imageAlt="A hiker standing on a summit rock looking out over sunlit mountains"
      />

      <section className="py-24 lg:py-32" data-testid="biz-tax-topics-section">
        <div className="container-shell">
          <Reveal className="max-w-3xl">
            <h2 className="font-serif text-3xl text-olive sm:text-4xl">What we talk about</h2>
            <p className="mt-5 text-base leading-relaxed text-moss sm:text-lg">These are planning topics, subject to confirmed service scope. Not promises of deductions, refunds, or savings.</p>
          </Reveal>
          <div className="mt-14 border-b border-line">
            {TOPICS.map((t, i) => (
              <DetailRow key={t.title} title={t.title} testId={`biz-tax-topic-${i + 1}`}>
                <p>{t.body}</p>
              </DetailRow>
            ))}
          </div>
          <Reveal className="mt-14 grid gap-6 md:grid-cols-2">
            <div className="rounded-md border border-olive/25 bg-sage p-8">
              <h3 className="font-serif text-xl text-olive">What to prepare</h3>
              <p className="mt-3 text-sm leading-relaxed text-moss">Current bookkeeping (or a honest sense of where it stands), last year’s return if you have it, a list of what’s changed in the business, and your questions. Written down or not.</p>
            </div>
            <div className="rounded-md border border-olive/25 bg-sage p-8">
              <h3 className="font-serif text-xl text-olive">How to get started</h3>
              <p className="mt-3 text-sm leading-relaxed text-moss">Book a consultation online, call, or send the inquiry form and mention business tax planning. We’ll confirm scope together in the first conversation.</p>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaSection heading="Give this year a head start." body="Book a business tax planning conversation, or send us a note about what’s changing in your business." />
    </>
  );
}
